import { memoize } from '@exodus/basic-utils';
import { createReduxModuleHelper } from '@exodus/multi-account-redux';
import id from './id.js';
const helper = createReduxModuleHelper({
    slice: id,
    createInitialPerAssetData: memoize(({ asset }) => ({ balance: asset.currency.ZERO }), ({ asset }) => asset.name),
    assetSourceDataSelectors: [
        { name: 'balance', selector: (assetData) => assetData.balance },
    ],
});
export default helper;
